<template>
	<li class="editable-item">
		<slot></slot>
		<transition name="slide">
			<div class="delete-btn" 
			v-show="editablelist.length>1"
			@click="deleteItem(editablelist[item-1], editablelist)"><i class="icon-trash"></i></div>
		</transition>
	</li>
</template>
<script>

	export default {
		name: 'editableItem',
		props: {
			editablelist: {
				type: Array,
				default: function() {
					return [{},{}]
				}
			}
		},
		methods: {
			deleteItem(item, arr) {
				arr.remove(item)
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../../../docs/scss/variables';
	.slide-enter-active, .slide-leave-active {
		transition: all 0.5s;
	}
	.slide-enter, .slide-leave-to {
		transform: translateX(100%);
	}
	.editable-item { 
		position: relative;
		&:not(:nth-of-type(1)) {
			margin-top: 5px; 
		}
	}
	.delete-btn {
		background: red;
		background: #f6f6f6;
		position: absolute; 
		right: 0px; 
		top: 0px;
		width: 30px; 
		@include border-left();
		margin: 1px 1px 0 0;
		height: calc(100% - 2px);
		.icon-trash {
			cursor: pointer;
			display: inline-block;
			padding: 9px 6px;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			color: red;
			&:before { font-size: 16px; color: $font-light; transition: all .3s; }
			&:hover { &:before { color: $font-dark; } }
		} 
	}
</style>



// WEBPACK FOOTER //
// src/components/editablelist/editableItem.vue